module.exports = __webpack_public_path__ + "img/ico_utils_notice.67a4f677.svg";